import { Component, OnInit, inject, signal } from '@angular/core';
import { TableModule } from 'primeng/table';
import { LocalizationService } from '../../core/localization/localization.service';
import { AinPageComponent } from '../../shared/design-system/page.component';
import { AccountingDocumentRecord, FinanceApiService } from './finance-api.service';

@Component({
  standalone: true,
  selector: 'ain-finance-invoices',
  imports: [AinPageComponent, TableModule],
  template: `
    <ain-page [title]="title" [description]="description">
      <section class="layout">
        <div class="card">
          <p-table
            [value]="rows()"
            selectionMode="single"
            [selection]="selected()"
            (selectionChange)="onSelect($event)"
            dataKey="id">
            <ng-template pTemplate="header">
              <tr>
                <th>{{ t('columns.code') }}</th>
                <th>{{ t('columns.basePrice') }}</th>
                <th>{{ t('columns.currency') }}</th>
                <th>Journal</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
              <tr [pSelectableRow]="row">
                <td>{{ row.number }}</td>
                <td>{{ row.amount }}</td>
                <td>{{ row.currencyCode }}</td>
                <td>{{ row.journalEntryId ?? '-' }}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>

        <div class="card detail">
          <h3>{{ detailTitle }}</h3>
          @if (!selected()) {
            <p class="muted">{{ t('finance.documents.selectRecord') }}</p>
          } @else {
            <dl>
              <dt>ID</dt><dd>{{ selected()?.id }}</dd>
              <dt>{{ t('columns.code') }}</dt><dd>{{ selected()?.number }}</dd>
              <dt>Idempotency Key</dt><dd>{{ selected()?.idempotencyKey }}</dd>
              <dt>{{ t('columns.basePrice') }}</dt><dd>{{ selected()?.amount }}</dd>
              <dt>{{ t('columns.currency') }}</dt><dd>{{ selected()?.currencyCode }}</dd>
              <dt>Journal Entry</dt><dd>{{ selected()?.journalEntryId ?? '-' }}</dd>
              <dt>Posting Error</dt><dd>{{ selected()?.postingErrorCode ?? '-' }}</dd>
            </dl>
          }
        </div>
      </section>
    </ain-page>
  `,
  styles: [`
    .layout { display: grid; grid-template-columns: minmax(0, 2fr) minmax(280px, 1fr); gap: 12px; }
    .card { border: 1px solid #e5e7eb; border-radius: 10px; padding: 12px; background: #fff; }
    .detail h3 { margin-top: 0; }
    .muted { color: #64748b; margin: 0; }
    dl { display: grid; grid-template-columns: 130px minmax(0, 1fr); gap: 6px 10px; margin: 0; }
    dt { color: #475569; font-weight: 600; }
    dd { margin: 0; word-break: break-word; }
  `]
})
export class FinanceInvoicesComponent implements OnInit {
  private readonly api = inject(FinanceApiService);
  private readonly localization = inject(LocalizationService);

  readonly rows = signal<AccountingDocumentRecord[]>([]);
  readonly selected = signal<AccountingDocumentRecord | null>(null);

  readonly title = 'صدور فاکتور';
  readonly description = 'لیست اسناد فاکتور و جزئیات هر سند';
  readonly detailTitle = 'جزئیات سند';

  ngOnInit(): void {
    this.api.listAccountingInvoices().subscribe({
      next: data => {
        this.rows.set(data);
        this.selected.set(data[0] ?? null);
      },
      error: () => {
        this.rows.set([]);
        this.selected.set(null);
      }
    });
  }

  onSelect(row: AccountingDocumentRecord | null): void {
    this.selected.set(row);
  }

  t(key: string): string {
    return this.localization.translate(key);
  }
}
